import React from 'react';
import Views from '../views';
import NumberView from '../views/textNumber-input/numberView';

const TextNumberEntryView = ({title, left, right, ...props}) => {
  return (
    <Views title={title} left={left} right={right}>
      <NumberView {...props} />
    </Views>
  );
};

export default TextNumberEntryView;
